module.exports = __webpack_public_path__ + "static/media/Satoshi-Bold.d4db658f.woff2";